export const defaultLanguage = "it-IT";
export const defaultBrand = "savio";
export const defaultContext = "spareparts";


export const gridSearchLayout: string = "G";
export const tableSearchLayout: string = "T";

export const defaultLayoutSearch: string = tableSearchLayout;

export const locales = [
  {
    code: "en-US",
    name: "English",
    dir: "ltr",
  },
  {
    code: "it-IT",
    name: "Italiano",
    dir: "ltr",
  },
  {
    code: "fr-FR",
    name: "French",
    dir: "ltr",
  },
];
